import MaintenanceSchedules from "../../../ServiceAgent/Schedules/vehicleAllSchedules";

export default MaintenanceSchedules;
